import { Props } from 'shared/@types';
import { Text } from 'shared/components/text';
import React from 'react';
import { clsx } from 'clsx';

export function FormWizardTitle({
  children,
  center = false,
  className,
}: Props<{ center?: boolean; className?: string }>) {
  return (
    <Text
      accessibilityRole={'header'}
      aria-level={2}
      className={clsx(
        'text-brand-brown-dark text-2xl font-semibold md:text-3xl',
        {
          'text-center': center,
        },
        className,
      )}
    >
      {children}
    </Text>
  );
}

export function FormWizardDescription({
  children,
  center = false,
  className,
}: Props<{ center?: boolean; className?: string }>) {
  return (
    <Text
      className={clsx(
        'text-brand-brown-dark/70 mt-1.5 md:text-lg',
        { 'text-center': center },
        className,
      )}
    >
      {children}
    </Text>
  );
}

// Title above a single input or group of fields inside a wizard step.
export function FormWizardLabel({ children, className }: Props<{ className?: string }>) {
  return <Text className={clsx('text-brand-brown-dark font-bold', className)}>{children}</Text>;
}
